import { userOrgApi as api } from './userOrgSlice';
const injectedRtkApi = api.injectEndpoints({
    endpoints: build => ({
        getApiAdministrationProject: build.query<
            GetApiAdministrationProjectApiResponse,
            GetApiAdministrationProjectApiArg
        >({
            query: queryArg => ({
                url: `/api/Administration/Project`,
                params: {
                    ProjectShortName: queryArg.projectShortName,
                    DomainId: queryArg.domainId,
                    StartDate: queryArg.startDate,
                    EndDate: queryArg.endDate,
                },
            }),
        }),
        getApiAdministrationProjectTag: build.query<
            GetApiAdministrationProjectTagApiResponse,
            GetApiAdministrationProjectTagApiArg
        >({
            query: () => ({ url: `/api/Administration/ProjectTag` }),
        }),
        getApiAdministrationUser: build.query<GetApiAdministrationUserApiResponse, GetApiAdministrationUserApiArg>({
            query: queryArg => ({
                url: `/api/Administration/User`,
                params: { ProjectShortName: queryArg.projectShortName, IdpUserId: queryArg.idpUserId },
            }),
        }),
        getApiAdministrationLocation: build.query<
            GetApiAdministrationLocationApiResponse,
            GetApiAdministrationLocationApiArg
        >({
            query: queryArg => ({
                url: `/api/Administration/Location`,
                params: { ProviderName: queryArg.providerName, LocationTypeId: queryArg.locationTypeId },
            }),
        }),
        getApiAdministrationLocationById: build.query<
            GetApiAdministrationLocationByIdApiResponse,
            GetApiAdministrationLocationByIdApiArg
        >({
            query: queryArg => ({ url: `/api/Administration/Location/${queryArg.id}` }),
        }),
        getApiAdministrationProvider: build.query<
            GetApiAdministrationProviderApiResponse,
            GetApiAdministrationProviderApiArg
        >({
            query: queryArg => ({ url: `/api/Administration/Provider`, params: { CountryCode: queryArg.countryCode } }),
        }),
        getApiAdministrationProviderById: build.query<
            GetApiAdministrationProviderByIdApiResponse,
            GetApiAdministrationProviderByIdApiArg
        >({
            query: queryArg => ({ url: `/api/Administration/Provider/${queryArg.id}` }),
        }),
        putApiAdministrationPromoteToProviderAdmin: build.mutation<
            PutApiAdministrationPromoteToProviderAdminApiResponse,
            PutApiAdministrationPromoteToProviderAdminApiArg
        >({
            query: queryArg => ({
                url: `/api/Administration/PromoteToProviderAdmin`,
                method: 'PUT',
                params: { IdpUserId: queryArg.idpUserId, ProviderId: queryArg.providerId },
            }),
        }),
        putApiAdministrationResetToPlatformUser: build.mutation<
            PutApiAdministrationResetToPlatformUserApiResponse,
            PutApiAdministrationResetToPlatformUserApiArg
        >({
            query: queryArg => ({
                url: `/api/Administration/ResetToPlatformUser`,
                method: 'PUT',
                params: { IdpUserId: queryArg.idpUserId },
            }),
        }),
        getApiAdministrationRequests: build.query<
            GetApiAdministrationRequestsApiResponse,
            GetApiAdministrationRequestsApiArg
        >({
            query: queryArg => ({
                url: `/api/Administration/Requests`,
                params: { State: queryArg.state, Type: queryArg['type'], ProjectShortName: queryArg.projectShortName },
            }),
        }),
        deleteApiAdministrationCache: build.mutation<
            DeleteApiAdministrationCacheApiResponse,
            DeleteApiAdministrationCacheApiArg
        >({
            query: () => ({ url: `/api/Administration/Cache`, method: 'DELETE' }),
        }),
        getApiEnumsLocationTypes: build.query<GetApiEnumsLocationTypesApiResponse, GetApiEnumsLocationTypesApiArg>({
            query: () => ({ url: `/api/Enums/LocationTypes` }),
        }),
        getApiLocation: build.query<GetApiLocationApiResponse, GetApiLocationApiArg>({
            query: queryArg => ({
                url: `/api/Location`,
                params: { ProviderName: queryArg.providerName, LocationTypeId: queryArg.locationTypeId },
            }),
        }),
        postApiLocation: build.mutation<PostApiLocationApiResponse, PostApiLocationApiArg>({
            query: queryArg => ({ url: `/api/Location`, method: 'POST', body: queryArg.locationCreate }),
        }),
        putApiLocation: build.mutation<PutApiLocationApiResponse, PutApiLocationApiArg>({
            query: queryArg => ({ url: `/api/Location`, method: 'PUT', body: queryArg.locationUpdate }),
        }),
        getLocation: build.query<GetLocationApiResponse, GetLocationApiArg>({
            query: queryArg => ({ url: `/api/Location/${queryArg.id}` }),
        }),
        deleteApiLocationById: build.mutation<DeleteApiLocationByIdApiResponse, DeleteApiLocationByIdApiArg>({
            query: queryArg => ({ url: `/api/Location/${queryArg.id}`, method: 'DELETE' }),
        }),
        getApiProvider: build.query<GetApiProviderApiResponse, GetApiProviderApiArg>({
            query: queryArg => ({ url: `/api/Provider`, params: { CountryCode: queryArg.countryCode } }),
        }),
        postApiProvider: build.mutation<PostApiProviderApiResponse, PostApiProviderApiArg>({
            query: queryArg => ({ url: `/api/Provider`, method: 'POST', body: queryArg.providerCreate }),
        }),
        putApiProvider: build.mutation<PutApiProviderApiResponse, PutApiProviderApiArg>({
            query: queryArg => ({ url: `/api/Provider`, method: 'PUT', body: queryArg.providerUpdate }),
        }),
        getProvider: build.query<GetProviderApiResponse, GetProviderApiArg>({
            query: queryArg => ({ url: `/api/Provider/${queryArg.id}` }),
        }),
        deleteApiProviderById: build.mutation<DeleteApiProviderByIdApiResponse, DeleteApiProviderByIdApiArg>({
            query: queryArg => ({ url: `/api/Provider/${queryArg.id}`, method: 'DELETE' }),
        }),
        getDataStagingLocations: build.query<GetDataStagingLocationsApiResponse, GetDataStagingLocationsApiArg>({
            query: () => ({ url: `/api/DataStaging/DataStagingLocations` }),
        }),
        updateDataStagingLocationKeys: build.mutation<
            UpdateDataStagingLocationKeysApiResponse,
            UpdateDataStagingLocationKeysApiArg
        >({
            query: queryArg => ({ url: `/api/DataStaging/DataStagingLocations`, method: 'POST', body: queryArg.body }),
        }),
        getKillSwitches: build.query<GetKillSwitchesApiResponse, GetKillSwitchesApiArg>({
            query: () => ({ url: `/api/Heappe/KillSwitch` }),
        }),
        getKillSwitch: build.query<GetKillSwitchApiResponse, GetKillSwitchApiArg>({
            query: queryArg => ({ url: `/api/Heappe/KillSwitch/${queryArg.providerName}/${queryArg.locationName}` }),
        }),
        setKillSwitch: build.mutation<SetKillSwitchApiResponse, SetKillSwitchApiArg>({
            query: queryArg => ({
                url: `/api/Heappe/KillSwitch/${queryArg.providerName}/${queryArg.locationName}`,
                method: 'PUT',
                body: queryArg.setLocationKillSwitchRequest,
            }),
        }),
        setKillSwitchWhitelist: build.mutation<SetKillSwitchWhitelistApiResponse, SetKillSwitchWhitelistApiArg>({
            query: queryArg => ({
                url: `/api/Heappe/KillSwitch/${queryArg.providerName}/${queryArg.locationName}/Whitelist`,
                method: 'PUT',
                body: queryArg.setLocationWhitelistRequest,
            }),
        }),
        setProviderKillSwitch: build.mutation<SetProviderKillSwitchApiResponse, SetProviderKillSwitchApiArg>({
            query: queryArg => ({
                url: `/api/Heappe/KillSwitch/${queryArg.providerName}`,
                method: 'PUT',
                body: queryArg.setProviderKillSwitchRequest,
            }),
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as userOrgAdministration };
export type GetApiAdministrationProjectApiResponse = /** status 200 OK */ ProjectModel[];
export type GetApiAdministrationProjectApiArg = {
    projectShortName?: ProjectShortName;
    domainId?: any;
    startDate?: string;
    endDate?: string;
};
export type GetApiAdministrationProjectTagApiResponse = /** status 200 OK */ ProjectTagModel[];
export type GetApiAdministrationProjectTagApiArg = void;
export type GetApiAdministrationUserApiResponse = /** status 200 OK */ UserModel[];
export type GetApiAdministrationUserApiArg = {
    projectShortName?: ProjectShortName;
    idpUserId?: string;
};
export type GetApiAdministrationLocationApiResponse = /** status 200 OK */ LocationModel[];
export type GetApiAdministrationLocationApiArg = {
    providerName?: string;
    locationTypeId?: any;
};
export type GetApiAdministrationLocationByIdApiResponse = /** status 200 OK */ ProviderModel;
export type GetApiAdministrationLocationByIdApiArg = {
    id: string;
};
export type GetApiAdministrationProviderApiResponse = /** status 200 OK */ ProviderModel[];
export type GetApiAdministrationProviderApiArg = {
    countryCode?: string;
};
export type GetApiAdministrationProviderByIdApiResponse = /** status 200 OK */ ProviderModel;
export type GetApiAdministrationProviderByIdApiArg = {
    id: string;
};
export type PutApiAdministrationPromoteToProviderAdminApiResponse = unknown;
export type PutApiAdministrationPromoteToProviderAdminApiArg = {
    idpUserId: string;
    providerId: string;
};
export type PutApiAdministrationResetToPlatformUserApiResponse = unknown;
export type PutApiAdministrationResetToPlatformUserApiArg = {
    idpUserId: string;
};
export type GetApiAdministrationRequestsApiResponse = /** status 200 OK */
    | RequestModel[]
    | /** status 204 No Content */ Blob;
export type GetApiAdministrationRequestsApiArg = {
    state?: ERequestState;
    type?: ERequestType;
    projectShortName?: ProjectShortName;
};
export type DeleteApiAdministrationCacheApiResponse = unknown;
export type DeleteApiAdministrationCacheApiArg = void;
export type GetApiEnumsLocationTypesApiResponse = /** status 200 OK */ any;
export type GetApiEnumsLocationTypesApiArg = void;
export type GetApiLocationApiResponse = /** status 200 OK */ LocationModel[];
export type GetApiLocationApiArg = {
    providerName?: string;
    locationTypeId?: any;
};
export type PostApiLocationApiResponse = unknown;
export type PostApiLocationApiArg = {
    locationCreate: LocationCreate;
};
export type PutApiLocationApiResponse = unknown;
export type PutApiLocationApiArg = {
    locationUpdate: LocationUpdate;
};
export type GetLocationApiResponse = /** status 200 OK */ LocationModel;
export type GetLocationApiArg = {
    id: string;
};
export type DeleteApiLocationByIdApiResponse = unknown;
export type DeleteApiLocationByIdApiArg = {
    id: string;
};
export type GetApiProviderApiResponse = /** status 200 OK */ ProviderModel[];
export type GetApiProviderApiArg = {
    countryCode?: string;
};
export type PostApiProviderApiResponse = unknown;
export type PostApiProviderApiArg = {
    providerCreate: ProviderCreate;
};
export type PutApiProviderApiResponse = unknown;
export type PutApiProviderApiArg = {
    providerUpdate: ProviderUpdate;
};
export type GetProviderApiResponse = /** status 200 OK */ ProviderModel;
export type GetProviderApiArg = {
    id: string;
};
export type DeleteApiProviderByIdApiResponse = unknown;
export type DeleteApiProviderByIdApiArg = {
    id: string;
};
export type GetDataStagingLocationsApiResponse = /** status 200 OK */ DataStagingLocationKey[];
export type GetDataStagingLocationsApiArg = void;
export type UpdateDataStagingLocationKeysApiResponse = /** status 200 OK */ BulkUpdateResult;
export type UpdateDataStagingLocationKeysApiArg = {
    body: string;
};
export type GetKillSwitchesApiResponse = /** status 200 OK */ KillSwitchLocationState[];
export type GetKillSwitchesApiArg = void;
export type GetKillSwitchApiResponse = /** status 200 OK */ LocationKillSwitchDetail;
export type GetKillSwitchApiArg = {
    providerName: string;
    locationName: string;
};
export type SetKillSwitchApiResponse = /** status 200 OK */ KillSwitchLocationUpdateResult;
export type SetKillSwitchApiArg = {
    providerName: string;
    locationName: string;
    setLocationKillSwitchRequest: SetLocationKillSwitchRequest;
};
export type SetKillSwitchWhitelistApiResponse = /** status 200 OK */ LocationKillSwitchDetail;
export type SetKillSwitchWhitelistApiArg = {
    providerName: string;
    locationName: string;
    setLocationWhitelistRequest: SetLocationWhitelistRequest;
};
export type SetProviderKillSwitchApiResponse = /** status 200 OK */ KillSwitchProviderUpdateResult;
export type SetProviderKillSwitchApiArg = {
    providerName: string;
    setProviderKillSwitchRequest: SetProviderKillSwitchRequest;
};
export type ProjectId = any;
export type EOperationModeResponse = 'Unspecified' | 'ReadOnly' | 'Editable';
export type ProjectModel = {
    Id?: null | ProjectId;
    Name?: any;
    ShortName?: any;
    Description?: any;
    ContactEmail?: any;
    StartDate?: any;
    EndDate?: any;
    DomainId?: any;
    OperationMode?: EOperationModeResponse;
    AssignedProjectResourceIds?: string[];
    AssignedTags?: string[];
};
export type ProjectShortName = any;
export type ProjectTagModel = {
    Id?: any;
    Name?: any;
    Description?: any;
};
export type UserModel = {
    IdpUserId: string;
    Email: string;
    UserName: string;
    InProjects: any;
    AdminForProviderId: any;
};
export type ProviderModel = {
    Id?: any;
    Name?: any;
    Description?: any;
    Country?: any;
    SupportEmail?: any;
    OperationMode?: EOperationModeResponse;
};
export type LocationModel = {
    Id?: any;
    Name?: any;
    Description?: any;
    Endpoint?: any;
    Provider?: null | ProviderModel;
    LocationTypeId?: any;
    OperationMode?: EOperationModeResponse;
    IsShared?: boolean;
    DefaultServiceIntegrationUrl?: any;
};
export type RequestModel = {
    RequestId?: any;
    IdpUserId?: any;
    UserName?: any;
    Email?: any;
    ProjectShortName?: null | ProjectShortName;
    State?: any;
    Type?: any;
    LastModification?: string;
};
export type ERequestState = 'Pending' | 'PendingForPIAccept' | 'PendingForHPCProject' | 'Accepted' | 'Rejected';
export type ERequestType = 'Unknown' | 'SelfOnboarding' | 'ProjectResourceAssignment' | 'HEAppECreation';
export type LocationCreate = {
    Name?: any;
    Description?: any;
    IsPrivate?: boolean;
    Endpoint?: any;
    ProviderId?: any;
    LocationTypeId?: any;
    IsShared?: boolean;
    DefaultServiceIntegrationUrl?: any;
};
export type LocationUpdate = {
    Id?: any;
    Name?: any;
    Description?: any;
    IsPrivate?: boolean;
    Endpoint?: any;
    ProviderId?: any;
    LocationTypeId?: any;
    IsShared?: boolean;
    DefaultServiceIntegrationUrl?: any;
};
export type ProviderCreate = {
    Name?: any;
    Description?: any;
    IsPrivate?: boolean;
    CountryCode?: any;
    SupportEmail?: any;
};
export type ProviderUpdate = {
    Id?: any;
    Name?: any;
    Description?: any;
    IsPrivate?: boolean;
    CountryCode?: any;
    SupportEmail?: any;
};
export type DataStagingLocationKey = {
    BackupKey?: any;
    Key?: any;
    Name?: any;
    JsonData?: string;
};
export type BulkUpdateResult = {
    Created: any;
    Updated: any;
    Deleted: any;
};
export type KillSwitchLocationState = {
    ProviderName: string;
    LocationName: string;
    IsEnforced: boolean;
    Reason: any;
    EnforcedAtUtc: any;
    IgnoreWhitelist: boolean;
};
export type KillSwitchTemplateState = {
    ProjectShortName: string;
    ResourceName: string;
    TemplateName: string;
    StoredState: string;
    EffectiveState: string;
    Whitelisted: boolean;
};
export type LocationKillSwitchDetail = {
    ProviderName: string;
    LocationName: string;
    IsEnforced: boolean;
    Reason: any;
    EnforcedAtUtc: any;
    IgnoreWhitelist: boolean;
    Templates: KillSwitchTemplateState[];
};
export type KillSwitchWhitelistItem = {
    ProjectShortName: string;
    ResourceName: string;
    TemplateName: string;
};
export type KillSwitchResyncItem = {
    ProjectShortName: string;
    ResourceName: string;
};
export type KillSwitchLocationUpdateResult = {
    ProviderName: string;
    LocationName: string;
    IsEnforced: boolean;
    StillAllowed: KillSwitchWhitelistItem[];
    UnqueuedResyncItems: KillSwitchResyncItem[];
};
export type SetLocationKillSwitchRequest = {
    IsEnforced: boolean;
    Reason: any;
    IgnoreWhitelist?: boolean;
};
export type SetLocationWhitelistRequest = {
    Items: KillSwitchWhitelistItem[];
};
export type KillSwitchProviderUpdateResult = {
    ProviderName: string;
    IsEnforced: boolean;
    AffectedLocationCount: any;
    StillAllowedCount: any;
    UnqueuedResyncItems: KillSwitchResyncItem[];
};
export type SetProviderKillSwitchRequest = {
    IsEnforced: boolean;
    Reason: any;
    IgnoreWhitelist?: boolean;
};
export const {
    useGetApiAdministrationProjectQuery,
    useGetApiAdministrationProjectTagQuery,
    useGetApiAdministrationUserQuery,
    useGetApiAdministrationLocationQuery,
    useGetApiAdministrationLocationByIdQuery,
    useGetApiAdministrationProviderQuery,
    useGetApiAdministrationProviderByIdQuery,
    usePutApiAdministrationPromoteToProviderAdminMutation,
    usePutApiAdministrationResetToPlatformUserMutation,
    useGetApiAdministrationRequestsQuery,
    useDeleteApiAdministrationCacheMutation,
    useGetApiEnumsLocationTypesQuery,
    useGetApiLocationQuery,
    usePostApiLocationMutation,
    usePutApiLocationMutation,
    useGetLocationQuery,
    useDeleteApiLocationByIdMutation,
    useGetApiProviderQuery,
    usePostApiProviderMutation,
    usePutApiProviderMutation,
    useGetProviderQuery,
    useDeleteApiProviderByIdMutation,
    useGetDataStagingLocationsQuery,
    useUpdateDataStagingLocationKeysMutation,
    useGetKillSwitchesQuery,
    useGetKillSwitchQuery,
    useSetKillSwitchMutation,
    useSetKillSwitchWhitelistMutation,
    useSetProviderKillSwitchMutation,
} = injectedRtkApi;
